export default __webpack_public_path__ + "static/white-nr-grey-desserto-a3444978a72ffd059dcfef72b8d08ea9.jpg";